export const ALBUM_NAVIGATION_DIRECTIONS = {
  previous: 'PREVIOUS',
  next: 'NEXT',
};

export const ALBUM_NAVIGATION_DIRECTIONS_LIST = Object.values(ALBUM_NAVIGATION_DIRECTIONS);
